import { useState } from "react";
import Linkify from "react-linkify";
import moment from "moment";
import FeedOptions from "../FeedOptions/FeedOptions";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import EndPoints from "src/Constants/EndPoints";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import { Link, useRouteMatch } from "react-router-dom";
import SnackbarHandler from "src/Utils/SnackbarHandler";
import ReportModal from "../ReportModal/ReportModal";
import PostModal from "../PostModal/PostModal";
import useLoading from "src/Hooks/Custom/useLoading";
import { useTranslation } from "react-i18next";
import ReactPlayer from 'react-player';
import i18n from "src/locales/i18n";

function PostDetail({
  postId,
  groupId: gId,
  postData,
  setPostData,
}: any) {
  const { t, i18n } = useTranslation();
  const { path } = useRouteMatch();
  const [loader] = useState("inactive");
  const [activeIndex, setActiveIndex] = useState(0);
  const [reportData, setReportData] = useState<any>();
  const [showReportModal, setShowReportModal] = useState<boolean>(false)
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);
  const [commentText, setCommentText] = useState("");
  const { user } = AppStateHandler.getState();
  const detailUrl = gId
    ? EndPoints.postDetail +
    "?postId=" +
    postId +
    "&groupId=" +
    gId +
    "&subId=" +
    user?.username
    : EndPoints.postDetail + "?postId=" + postId + "&subId=" + user?.username;
  const { data: detailResponse, refetch: postRefetch } = useApiFetch([detailUrl], {});
  const postDetail = detailResponse?.data?.data ?? postData;
  const {
    id,
    groupId,
    user_name,
    user_image = "/assets/images/profile-camera.png",
    images,
    subId,
    message,
    likes,
    total_comments,
    is_like,
    is_bookmark,
    location,
  } = postDetail;
  useLoading(loader);

  const getCommentsUrl =
    EndPoints.comments +
    "?postId=" +
    postId +
    "&subId=" +
    user?.username +
    (groupId ? "&groupId=" + groupId : "");
  const { data: commentsResponse, refetch } = useApiFetch([getCommentsUrl], {});

  const { Items: comments = [] } = commentsResponse?.data ?? {};
  const [like, { status: likeStatus }] = useApiMutation({
    onSuccess: () => {
      postDetail.is_like = !postDetail.is_like;
      postDetail.likes = postDetail.is_like
        ? postDetail.likes + 1
        : postDetail.likes - 1;
    },
  });

  const [likeComment, { status: likeCStatus }] = useApiMutation({
    onSuccess: () => {
      refetch();
    },
  });

  const likePost = async () => {
    if (likeStatus === "loading") {
      return;
    }
    if (user.username === subId || !user.username) {
      SnackbarHandler.likeErrorToast("You can't like your own post.");
      return;
    }
    try {
      await like({
        url: EndPoints.likePost,
        data: {
          subId: user?.username,
          postId: id,
          groupId: groupId,
        },
      });
    } catch (error) { }
  };

  const likePostComment = async (comment: any) => {
    if (likeCStatus === "loading") {
      return;
    }
    if (user.username === comment.subId || !user.username) {
      SnackbarHandler.likeErrorToast("You can't like your own comment.");
      return;
    }
    try {
      await likeComment({
        url: EndPoints.likeComment,
        data: {
          subId: user?.username,
          commentId: comment.id,
          groupId: groupId,
        },
      });
    } catch (error) { }
  };

  const [commentPost, { status: commentStatus }] = useApiMutation({
    onSuccess: () => {
      setCommentText("");
      refetch();
    },
  });

  const commentHandler = async (e: any) => {
    e.preventDefault();
    if (commentStatus === "loading") {
      return;
    }
    if(commentText.trim()==='') {
      SnackbarHandler.emptyCommentWarningToast(t("Please add a comment"));
      return;
    }
    try {
      await commentPost({
        url: EndPoints.commentOnPost,
        data: {
          postId: id,
          subId: user?.username,
          groupId: groupId,
          comment: commentText,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleReportComment = (id: number) => {
    const report = {
      data: { commentId: id },
      type: "post",
      endPoint: EndPoints.reportComment,
    };
    setReportData(report);
    setShowReportModal(true);
  };
  const msg_url = message?.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);

  return (
    <div className="post post_feed">
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between px-3">
          <div className="d-flex align-items-center ">
          <div className={`mb-4 mb-md-0 ${i18n.dir() === "rtl"  ? "ml-3" : "mr-3"}`}>
              <Link to={path.replace("/:id", "").replace(":postId", groupId)}>
                <i
                  className={`fa  fz24 cursor-pointer p-2 ${i18n.dir()==='rtl'?'fa-angle-right':'fa-angle-left'}`}
                  aria-hidden="true"
                ></i>
              </Link>
            </div>
            <div className={`mb-4 mb-md-0 ${i18n.dir() === "rtl"  ? "ml-3" : "mr-3"}`}>
              <img
                src={
                  user_image !== ""
                    ? user_image
                    : "/assets/images/profile-camera.png"
                }
                className="rounded-circle object_fit"
                width="40"
                height="40"
                alt="icon"
              />
            </div>
            <div>
              <h3 className="fz16 poppinssemibold mb-0">{user_name}</h3>
              <p className={`fz10 mb-0 text-secondary ${i18n.dir() === "rtl" ? "Almaraisemibold text-right" : "poppinsregular" }`}>
                {location ? location : ""}{" "}
                <span className={i18n.dir() === "rtl" ? "mr-3" : "ml-3"}>
                  <i className={`fa fa-circle fz6 ${i18n.dir() === "rtl"  ? "ml-1" : "mr-1"}`} aria-hidden="true"></i>
                  {id ? moment(new Date(id)).fromNow() : ""}
                </span>
              </p>
            </div>
          </div>
          <FeedOptions
            id={id}
            groupId={groupId}
            subId={subId}
            is_bookmark={is_bookmark}
            data={postDetail}
            setPostData={setPostData}
            setReportData={setReportData}
            setShowReportModal={setShowReportModal}
            setModalVisibility={setModalVisibility}
          />
        </div>
        <div className="slider_section my-4">
          <div
            id="demo"
            className="carousel slide"
            data-ride="carousel"
            data-interval="30000000"
          >
            <ul className="carousel-indicators">
              {(Array.isArray(images) ? images : []).map(
                (_: any, _i: number) => (
                  <li
                    className={_i === activeIndex ? "active" : ""}
                    data-target="#demo"
                    key={_i}
                    data-slide-to={_i}
                    onClick={() => setActiveIndex(_i)}
                  ></li>
                )
              )}
            </ul>
            <div className="carousel-inner">
              {(Array.isArray(images) ? images : []).map(
                ({ url }: any, _i: number) => (
                  <div
                    key={_i}
                    className={`carousel-item text-center ${_i === activeIndex ? "active" : ""
                      }`}
                  >
                    <a href="/" className="d-inline-block">
                      <img
                        src={url}
                        key={_i}
                        alt="Los Angeles"
                        className="img-fluid post-img w-100 object_fit"
                      />
                    </a>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <div className="px-3">
          <Linkify>
            <p className={`mb-0 text-secondary fz16  post_message ${i18n.dir() === "rtl"  ? "Almaraisemibold text-right" : "poppinsregular"}`}>
              {message}
            </p>
          </Linkify>
          {ReactPlayer.canPlay(msg_url)	 &&  <ReactPlayer url={msg_url} width={'100%'}/>}
        </div>
        <div className="px-3">
          <hr />
        </div>
        <div className="post_list px-3">
            <ul className={`list-unstyled d-flex mb-0 ${i18n.dir()==='rtl'?'pr-0':''}`}>
              <li className = {`${i18n.dir()==='rtl'?'post_li_rtl':'post_li_ltr'}`}>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  likePost();
                }}
              >
                <i
                  className={`fa ${is_like ? "fa-heart text-danger" : "fa-heart-o base_color" 
                  } ${i18n.dir()==='rtl'?'post_li_i_rtl':'post_li_i_ltr'}`}
                  aria-hidden="true"
                ></i>
                {likes ?? 0}
              </a>
            </li>
            <li>
              <a href="/">
                <i
                  className={`fa fa-comment-o base_color ${i18n.dir()==='rtl'?'post_li_i_rtl':'post_li_i_ltr'}`}
                  aria-hidden="true"
                ></i>
                {total_comments ?? comments.length}
              </a>
            </li>
          </ul>
        </div>
        <div className="py-5 px-3">
          <div className="mb-4">
            <h3 className={`fz16 mb-0 ${i18n.dir()==='rtl'?'text-right':''}`}>{t("Comments")}</h3>
          </div>
          {comments.map((comment: any, i: number) => {
            return (
              <div key={i} className="d-flex">
              <div className={i18n.dir() === "rtl"  ? "ml-3" : "mr-3"}>
                  <img
                    src={
                      comment.picture !== ""
                        ? comment.picture
                        : "/assets/images/profile-camera.png"
                    }
                    className="rounded-circle object_fit"
                    width="40"
                    height="40"
                    alt=""
                  />
                </div>
                <div className="w-100">
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className={`fz16 mb-1 mb-4 poppinssemibold ${i18n.dir()==='rtl' && 'text-right Almaraibold'}`}>
                      {comment.name} <br />
                      <i className={`fz10  text-secondary ${i18n.dir() === "rtl"  ? "mr-3 Almaraisemibold" : "ml-3 poppinsregular"}`}>
                        {comment.timestamp
                          ? moment(new Date(comment.timestamp)).fromNow()
                          : ""}
                      </i>
                    </h4>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                    <p className={`fz14 poppinsregular text-secondary pl-0 mb-0 ${i18n.dir() === "rtl" && "Almaraisemibold"}`}>
                      {comment.comment}
                    </p>
                    <span className="text-secondary fz12 cursor-pointer">
                      <i
                        className={`fa fz14 ${comment.is_like
                          ? "fa-heart text-danger"
                          : "fa-heart-o base_color"
                          }`}
                        aria-hidden="true"
                        onClick={() => likePostComment(comment)}
                      ></i>
                      <span
                        className={`${i18n.dir() === "rtl" ? "mr-2" : "ml-2"} exclamation`}
                        onClick={() => handleReportComment(comment.id)}
                      >
                        <i
                          className={`fa fa-exclamation base_color`}
                          aria-hidden="true"
                        ></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="d-flex">
            <div className="mr-3"></div>
            <div className="w-100 position-relative">
              <input
                type="text"
                value={commentText}
                className={`form-control ${i18n.dir() === "rtl"  ? "pl-5" : "pr-5"}`}
                style={{ backgroundColor: "rgb(245, 245, 245)" }}
                placeholder={t("Write a comment")}
                onChange={(e: any) => setCommentText(e.target.value)}
              />
              <VisibilityToggle visible={commentStatus === "loading"}>
                <span
                  className="spinner-border spinner-border-sm position-absolute"
                  style={{ right: i18n.dir() === "ltr" ? '40px' : '' , left : i18n.dir() === "rtl" ? '40px' : '' , top: "12px" }}
                ></span>
                &nbsp; &nbsp;
              </VisibilityToggle>
              <i
                className={`fa fa-paper-plane position-absolute base_color cursor-pointer ${i18n.dir()=== 'rtl' && 'fa-flip-horizontal'}`}
                style={{ right: `${i18n.dir()==='rtl'?'':'18px'}`, top: "12px", left:`${i18n.dir()==='rtl'?'18px':''}` }}

                aria-hidden="true"
                onClick={commentHandler}
              ></i>
            </div>
          </div>
        </div>
      </div>
      {showReportModal ? (
        <ReportModal
          data={reportData.data}
          setData={setReportData}
          type={reportData.type}
          showModal={showReportModal}
          setModalVisibility={setShowReportModal}
          endPoint={reportData.endPoint}
        />
      ) : (
          <></>
        )}
      {
        modalVisibility ? (
          <PostModal
            postData={postData}
            setPostData={setPostData}
            showModal={modalVisibility}
            setModalVisibility={setModalVisibility}
            refetch={postRefetch}
          />
        ) : (
            <></>
          )
      }
    </div>
  );
}

export default PostDetail;
